import Phaser from 'phaser';
import type { SceneCallbacks } from './types';
import type { CleaningModel } from '../systems/CleaningModel';
import { CleaningScene, GAME_CONFIG_SIZE } from '../scenes/CleaningScene';

export interface PhaserHandle {
  game: Phaser.Game;
  scene: CleaningScene;
}

export function createPhaserGame(model: CleaningModel, callbacks: SceneCallbacks): PhaserHandle {
  const scene = new CleaningScene(model, callbacks);
  const game = new Phaser.Game({
    type: Phaser.AUTO,
    parent: 'phaser-game',
    width: GAME_CONFIG_SIZE.width,
    height: GAME_CONFIG_SIZE.height,
    backgroundColor: '#f7fbff',
    transparent: false,
    scene: [scene],
    render: {
      antialias: true,
      pixelArt: false,
      roundPixels: false,
    },
    scale: {
      mode: Phaser.Scale.FIT,
      autoCenter: Phaser.Scale.CENTER_BOTH,
    },
    input: {
      activePointers: 1,
      touch: { capture: true },
    },
  });
  return { game, scene };
}
